import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { getServiceAccountingList, getStaffPerformance_ServiceCostList, getStaffPerformance_ServiceTotalCost } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel, isWebApp, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const StaffPerformanceServiceCostList = () => {

    const history = useHistory();
    const { staffID } = useParams();
    const dispatch = useDispatch();
    const { filterData, parentFilterData, dataList } =
        useSelector(state => {
            return {
                parentFilterData: state.service.srvTotalCostFilters,
                filterData: state.service.staffSRVCostListFilters,
                dataList: state.service.staffSRVCostList
            }
        });
    const staffName = Array.isArray(dataList?.Data) ? " - " + dataList.Data[0].StaffName : "";
    const [pending, setPending] = useState(false);
    const [popStaff, setPopStaff] = useState({ show: false });
    const settingNames = ['ProductGrouppingType'];
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PServiceType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "PFirstContactDate", colTitle: "تاریخ پذیرش", showInMobile: true },
        { colName: "InvoiceNumber", colTitle: "شماره سرویس" },
        { colName: "PRowType", colTitle: "نوع خدمت", showInMobile: true },
        { colName: "CostDesc", colTitle: "شرح خدمت" },
        { colName: "Status", colTitle: "وضعیت" },
        { colName: "ServiceCount", colTitle: "تعداد", colType: "currency" },
        { colName: "ServiceCost", colTitle: "مبلغ واحد", colType: "currency" },
        { colName: "RowDiscount", colTitle: "تخفیف", colType: "currency" },
        { colName: "TaxAmount", colTitle: "مالیات", colType: "currency" },
        { colName: "StaffShare", colTitle: "سهم تکنسین", colType: "currency" }
    ]
    function search() {
        const data = { ...parentFilterData };
        data.StaffID = staffID;
        //data.StaffHardCode = staffHardCode;
        data.Skip = 0;
        data.Take = 10;
        dispatch(getStaffPerformance_ServiceCostList(data));

    }
    function onTakeChanged(take) {
        const data = { ...filterData, Take: take, Skip: 0 };
        dispatch(getStaffPerformance_ServiceCostList(data));
    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/getStaffPerformance_ServiceCostList`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("StaffPerformanceServiceCostList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/StaffPerformanceServiceCostList/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/getStaffPerformance_ServiceCostList`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function gotoService(row) {
        history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        search();
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    گزارش عملکرد تکنسین(لیستی){staffName}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row>
                        <Col md={2} className="form-group" style={{ textAlign: "right" }}>
                            <label>تعداد در صفحه: </label>
                            <Form.Control as="select" onChange={e => onTakeChanged(e.target.value)}>
                                <option value={0}>انتخاب کنید</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Control>
                        </Col>
                    </Row>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="service" searchMethod={(data) => dispatch(getStaffPerformance_ServiceCostList(data))}
                        objectName="staffSRVCostList" filterData={filterData} hasPaging className="mt-0" rowClick={gotoService} style={{ whiteSpace: "nowrap" }} />
                    {isWebApp() &&
                        <div className="mt-1" style={{ color: "blue", textAlign: "left" }}>
                            برای نمایش سرویس روی ردیف مورد نظر کلیک کنید
                        </div>
                    }
                </Card.Body>
            </Card>
        </div>)
}
export default StaffPerformanceServiceCostList;